import * as React from "react";
import TaskForm from "./TaskForm";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import SectionView from "../../../layout/section/SectionView";
import Row from "../../../layout/Row";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../../layout/Col";

type Props = FormBodyProps<TaskForm>

export default class TaskFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<SectionView>
				<Row>
					<Col lg={12} xl={12}>
						<InputFormGroup label="Task name"
										placeholder="Enter task name"
										field={this.props.form.title}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.title)}/>
					</Col>
				</Row>
				<Row>
					<Col lg={12} xl={12}>
						<InputFormGroup label="Installer description"
										placeholder="Enter installer description"
										field={this.props.form.installerDescription}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.installerDescription)}/>
					</Col>
				</Row>
				<Row>
					<Col lg={12} xl={12}>
						<InputFormGroup label="Customer description"
										placeholder="Enter customer description"
										field={this.props.form.customerDescription}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.customerDescription)}/>
					</Col>
				</Row>
			</SectionView>
		);
	}
}
